function determineButtonText(windowWidth, mobileText, desktopText) {
  const isMobile = windowWidth < 540
  const hideMobileText = mobileText?.toLowerCase() === 'none'
  let buttonText = desktopText // Default to desktopText

  if (isMobile) {
    if (hideMobileText) {
      buttonText = '' // Hide text for mobile
    } else if (mobileText) {
      buttonText = mobileText // Use mobileText if available
    }
  }

  return buttonText
}

export default determineButtonText
